export default "__VITE_ASSET__BE$$aJYc__"